﻿import { defineComponent, PropType } from 'vue';

import { passenger } from "../../../../objects/v1_2/Booking/Passenger";
import { trip_passenger } from "../../../../objects/v1_2/Booking/Trip_Passenger";
// No longer used (and the module does not exist): import { product_price } from "../product/product_price";

import { Booking } from "../../../../services/booking";
import { Product } from "../../../../services/product";
import { Web_Engine } from "../../../../services/web_engine";
import { Currency_Service } from "../../../../../system/services/currency";

// No longer used: import passengers from '../../4_checkout/passengers';
import { product_search_product } from '../../../../objects/v1_3/product/search/product_search_product';

const Book = new Booking();
const Prod = new Product();
const Web_Engines = new Web_Engine();
const Currency_Services = new Currency_Service();
class GooglePassengerDetail {
    public age_cat: string = "";
    public count: number = 0;
    public price: number = 0;

}

export default defineComponent({
    name: "select_passengers",
    props: {
        price: String,
        passengers: { type: Array as PropType<passenger[]>, default: [] },
        parent_tour_id: String,
        tour_id: String,
        tour_details: {type: Object as PropType<product_search_product>, default: new product_search_product()},
        isEcoScheme: Boolean,
        isAddOn: Boolean,
        departure_date: { type: [String, null] as PropType<string | null>, default: null }
    },
    data() {
        return {
            isHidden: true,
            selected_passengers: [] as trip_passenger[],
            addingAddon: false
        }
    },
    methods: {
        Setup_Controls() {
            for (var index = 0; index < this.passengers.length; index++) {
                let trip_pax: trip_passenger = new trip_passenger();
                trip_pax.index = index;

                this.selected_passengers.push(trip_pax);
            }
        },

        Addon_In_Basket(): boolean {

            let return_value: boolean = false;
            this.$store.getters.get_Booking.trips.forEach((trip) => {
                if(this.tour_id?.toUpperCase().trim() == trip.tour_id.toUpperCase().trim()){
                    return_value = true;
                }
            });

            return return_value;
        },
        async add_AddOn() {

            console.log("Add Ons - " + this.isAddOn);
            this.addingAddon = true;
            this.$store.commit("Add_Add_On", { Parent_Tour_ID: this.parent_tour_id, Tour_ID: this.tour_id, Passengers: this.selected_passengers, add_on_product: this.tour_details });
            this.isHidden = true

            let Book = new Booking();
            this.$store.commit("Setup_Booking", { Booking_Details: await Book.Quote_Booking(this.$store) }); 

            this.addingAddon = false;
            if (Web_Engines.getSession_ID() == "")
            {
                this.$router.push({ path: "/cart", hash: "#basket_" + this.tour_id });
            }
            else {
                this.$router.push({ path: "/" + Web_Engines.get_Booking_URL() + "/cart/" + Web_Engines.getSession_ID(), hash: "#basket_" + this.tour_id });
            }

        },
        Passenger_Selected(index: number): boolean {
            return (this.selected_passengers.findIndex((f: trip_passenger) => f.index == index, 0) != -1);
        },
        Get_Price(Passenger: passenger): string {
            return Currency_Services.Format_Currency(Prod.Product_Pricing_From_date(Passenger.age_category ?? Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, this.tour_details ?? new product_search_product(), this.departure_date), this.$store.getters.get_Currency);
        },
        Toggle_Passenger(index: number) {
            let trip_pax: trip_passenger = new trip_passenger();
            trip_pax.index = index;

            let index_location: number = this.selected_passengers.findIndex((f: trip_passenger) => f.index == trip_pax.index, 0);
            if (index_location == -1) {
                this.selected_passengers.push(trip_pax);
            } else {
                this.selected_passengers.splice(index_location, 1);
            }
        },
        // Unique per add-on and trip (was "passenger_" + index, repeated for every add-on on the page,
        // so a label could tick a checkbox belonging to another add-on).
        Control_Name(index: number): string {
            return "addon_" + this.parent_tour_id + "_" + this.tour_id + "_pax_" + index;
        },
        // No longer used: one responsive layout replaced the separate desktop/mobile markup.
        // isMobile(): boolean{
        //     if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //         return true
        //     } else {
        //         return false
        //     }
        // },
        checkTickBox(passengerSelected: boolean): boolean {
            if(this.isEcoScheme){
                return false;
            }

            return passengerSelected;
        }
    },
    mounted() {
        this.Setup_Controls();
    }
})